import React from 'react';
import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const SwitchLabel = styled.span`
  font-size: 12px;
  color: ${props => (props.active ? '#59616a' : '#969ba1')};
  font-weight: ${props => (props.active ? '600' : 'normal')};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  
  @media (max-width: 768px) {
    font-size: 13px;
    gap: 4px;
  }
`;

const SwitchTrack = styled.div`
  position: relative;
  width: 44px;
  height: 24px;
  background: ${props => (props.isLeft ? '#FF6D22' : '#4A90E2')};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    width: 56px;
    height: 30px;
    border-radius: 15px;
  }
`;

const SwitchThumb = styled.div`
  position: absolute;
  top: 2px;
  left: ${props => (props.isLeft ? '2px' : '22px')};
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    top: 3px;
    width: 24px;            // PLUS GRAND
    height: 24px;
    left: ${props => (props.isLeft ? '3px' : '29px')};
  }
`;

const IconEmoji = styled.span`
  font-size: 14px;
  filter: ${props => (props.active ? 'grayscale(0%)' : 'grayscale(100%)')};
  opacity: ${props => (props.active ? '1' : '0.4')};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ToggleSwitch = ({ 
  leftLabel, 
  rightLabel, 
  leftIcon, 
  rightIcon, 
  value, 
  onChange 
}) => {
  const isLeft = value === 'left';
  
  const handleToggle = () => {
    onChange(isLeft ? 'right' : 'left');
  };
  
  const handleLeftClick = () => {
    if (!isLeft) onChange('left');
  };
  
  const handleRightClick = () => {
    if (isLeft) onChange('right');
  };
  
  return (
    <SwitchContainer>
      <SwitchLabel active={isLeft} onClick={handleLeftClick}>
        <IconEmoji active={isLeft}>{leftIcon}</IconEmoji>
        {leftLabel}
      </SwitchLabel>
      
      <SwitchTrack onClick={handleToggle} isLeft={isLeft}>
        <SwitchThumb isLeft={isLeft} />
      </SwitchTrack>
      
      <SwitchLabel active={!isLeft} onClick={handleRightClick}>
        <IconEmoji active={!isLeft}>{rightIcon}</IconEmoji>
        {rightLabel}
      </SwitchLabel>
    </SwitchContainer>
  );
};

export default ToggleSwitch;